import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: "en", // set locale
  fallbackLocale: "en",
  silentFallbackWarn: true,
  messages: {
    en: {
      heading: {
        appointment: "Appointments",
        welcome: "Welcome!",
        verify: "Verify Your Phone Number",
        enterCode: "Enter the 6-digit code we sent to:",
        selectVisit: "Select Visit Type",
        visitDetails:
          "What is the most important thing that you would like to discuss during this visit?",
        selectProvider: "Select a Provider",
        selectTime: "Available Dates are Selectable",
        confirmAppointment: "Confirm Appointment",
        telehealthVisit: "What is a Phone Visit?",
        thankyouResponses: "Thank You for Your Responses",
        navigationHome:
          "Your responses have been submitted. You will now be taken to the home page.",
        inPersonVisits: "Visits will be scheduled at ",
        inPersonVisit: "In-Person Visit",
        telephoneVisit: "Phone Visit",
        virtualVisit: "Virtual Visit",
        availableForms: "Available Forms",
        expiredLink: "This Link Is No Longer Active",
        goodMorning: "Good morning",
        goodAfternoon: "Good afternoon",
        goodEvening: "Good evening",
        familyMemberInstructions: "Instructions",
        callbackRequestReceived: "Call Back Request Received",
        noAppointments:
          "There are currently no appointments available in the next 2 weeks. Please try again later.",
        appointmentType: "What would you like to schedule?",
        schedulingYourVisit: "Schedule your {0}",
        howMayWeHelp: "How may we help you today?",
        upcomingAppointments: "Your Appointments",
        recommendedCare: "Recommended Care",
        goodFaithEstimate: "Good Faith Estimate",
      },
      common: {
        with: "with",
        at: "at",
        telehealth: "phone",
        yes: "yes",
        no: "no",
        cancel: "Cancel Appointment?",
        where: "at",
        clickHere: "Click here",
        detected: "detected",
        notDetected: "not detected",
        positive: "positive",
        negative: "negative",
        ordered: "ordered",
        before: "before",
      },
      information: {
        loggedOut: "For security purposes, you have been logged out.",
        inactive:
          "Due to inactivity, please call the Communication Center to schedule your next appointment at (303) 650-4460.",
        lafayetteDoubleBook:
          "This service is temporarily unavailable. We’re working to get it back up and running as soon as possible. Please call the Communication Center to schedule your next appointment at (303) 650-4460. Thank you for your patience!",
        dentalEvent:
          "You have selected to make an appointment for your dental exam. Please note that options to schedule an appointment will only appear if you are currently due for an exam. To make any other type of dental appointment, please call us at 303-650-4460.",
        inactiveTooLong:
          "Our records indicate that it has been over 3 years since you have seen a medical provider at Clinica Family Health & Wellness. Please call our Communication Center at 303.650.4460 to see if you are eligible to re-establish care with Clinica. Thank you.",
        noShow:
          "Due to a previously missed appointment, your care has been terminated. Please call the Communication Center for further assistance at (303) 650-4460.",
        fullPayOneTime:
          "You are unable to schedule an appointment until you meet with an Enrollment Specialist. Please call our Communication Center at 303.650.4460 to schedule an appointment with the Enrollment team or to get more information about the Enrollment department’s walk-in hours. Thank you.",
        fullPayDeclined:
          "Our records indicate that you do not have active insurance coverage or a Clinica discount",
        fullPayDeclinedReminder:
          " REMINDER: You are required to pay the $150 up front visit charge during check-in for this appointment or this appointment will be cancelled.",
        fullPayDeclinedEnd:
          "If you have updates to your insurance status, please call us at 303.650.4460 before your appointment or bring your new insurance card to your visit. Thank you.",
        fullPayDeclinedWest:
          "Adult wellness exam access is limited at Westminster. If you have a medical need outside of a physical or well exam please call the Communication Center at 303.650.4460 to discuss scheduling options. Thank you.",
        outOfServiceArea:
          "Our records indicate that you are outside of Clinica's service area. Please check to see if you are eligible to re-establish care with Clinica. For further assistance, call our Communication Center at (303) 650-4460. Thank you.",
        lafayetteParking:
          "Part of our Lafayette parking lot is being used to support our community impacted by the Marshall Fire. Patient parking has been preserved closest to the building. Please look here for parking.",
        covidVaccineLocations: `Please select your preferred location below.`,
        covidVaccineDisclaimer: `COVID vaccinations can not be scheduled using the options below. If you
        are eligible for a vaccine based on current state guidelines`,
        covidVaccineOffered:
          "We are now offering the Pfizer COVID-19 vaccine to patients 12 and up. Click here to schedule your vaccine now!",
        callbackRequestReceived: `Our staff will call you back to dicuss your COVID vaccine questions.
      Please know that we are currently experiencing high call volumes and a
      return call may take longer than 24 hours. Please do not submit multiple
      call requests. Thank you for your patience.`,
        covidPhase1: `<b
        >Clinica Family Health & Wellness is now offering the Pfizer COVID-19 vaccine for our
        patients who are 12 and
        older.</b
      >`,
        covidPhase1Requirements: `<b
        >IMPORTANT: If you are a first responder or health care worker, you must
        bring verification of employment to your appointment. </b
      >Acceptable forms of verification include:
      <ul class="pb-2">
        <li>
          Photo employee badge
        </li>
        <li>Pay stub and ID</li>
        <li>Letter from employer and ID</li>
      </ul>
      <b class="error--text"
        >According to state orders, we cannot vaccinate individuals who are not
        in this phase of the vaccination plan. </b
      >Please check Clinica's web site
      <a href="https://www.clinica.org" target="_blank">here</a>
      for more information about when you can get the vaccine.`,
        established: `​You can schedule online for most non-urgent appointments with your Care Team. Schedule your appointment below.`,
        // "​ <i>Sign-in below to access Clinica's online scheduling portal. Schedule your own <b class='primary-- text'>phone or in-person visit </b>and complete any pre-visit questionnaires.</i> ",
        virtualVisits:
          "Starting in May 2021, Clinica will be offering video virtual visits! Your care team looks forward to seeing you in person or virtually to ensure you get your health care needs met. To find out more on what to expect, please visit: <a target='_blank' href='https://www.lumahealth.io/telehealth-guides/telehealth-patient/'>Patient User Guide</a>",
        emergency:
          "If you think you are having a medical or behavioral health emergency, call 9-1-1 or go to your nearest Emergency Department. Do not use this portal for urgent needs.",
        bhEmergency: `If you think you are having a medical or behavioral health emergency, call 9-1-1 or the Colorado Crisis Line <a href="tel:988">988</a>`,
        prapareInfo: `Please complete this survey - it helps us understand your needs and provide better care`,
        enter: "Enter Your Information",
        noUpcomingAppointments:
          "You have no upcoming appointments. <br/> Schedule one using the + icon above.",
        noUpcomingAppointmentsBelow:
          "You have no upcoming appointments. Schedule a new appointment below.",
        upcomingAppointment: "You have one upcoming appointment",
        upcomingAppointments: "You have {number} upcoming appointments",
        checkIn:
          "Your check-in time is at {time}. Please bring your insurance card with you to your appointment.",
        telehealthCheckin:
          "We will contact you by phone within {time} minutes of your appointment time. We recommend taking your call from a quiet space if possible.",
        telehealthVisit:
          "A regular visit between you and your provider, but instead of meeting in person, your visit is conducted by phone using audio only",
        virtualVisit:
          "A regular visit between you and your provider, but instead of meeting in person, your visit is conducted by phone or your computer using full video and audio",
        enteredInformation:
          "Information provided must match your health record. You will need the phone entered below to receive your verification code.",
        quickLoginInformation:
          "Information provided must match your health record.",
        expiredQuickLink: `The link you have used is either expired or invalid. Please call us at
        <a href="tel:3036504460">303-650-4460</a> if you have any questions concerning your most recent COVID test.`,
        expiredQuickLinkVaccine: `The link you have used is either expired or invalid. Please click below to login and to schedule a COVID vaccine appointent. `,
        obDisclaimer: `If this is your first appointment with Clinica for <u>this pregnancy</u>, please call <a href="tel:3036504460">303.650.4460</a> to schedule visit.`,
        procedureDisclaimer: `Please do not schedule a procedure (IUD Insertions/Removals, Vasectomies, joint injections, wart removals, cast removals, etc.) using this system. To provide a great experience, please call <a href="tel:3036504460">303.650.4460</a> so that we can assure that you are getting scheduled with a provider who is able to perform your procedure.`,
        wellnessDisclaimer: `If you are over the age of 65, please note that your appointment will be allocated a 40-minute time slot to ensure a comprehensive and attentive consultation.`,
        insurance:
          "Please bring your insurance card with you to this appointment.",
        invalidStatus: `We are unable to process your scheduling request at this time; Please call Clinica at <a href="tel:3036504460">303.650.4460</a> to schedule an appointment.`,
        zpayStatus: `If you do not have insurance coverage at the time of your appointment you will be placed on a 30 day Self-Pay contract at the time of your appointment. For questions about self-pay please call Clinica at <a href="tel:3036504460">303.650.4460</a>`,
        inPersonVisit: `<h4>Please limit any visitors accompanying you to your visit:</h4>
                  <li> Access to the building is now restricted to only the person
                    with the appointment unless it is a child who needs one
                    parent or someone who needs assistance from one caregiver.
                  </li>
                  <li>
                    Anyone else who comes with you to your appointment will be
                    asked to wait outside the building or in their car.
                  </li>
                  <li>
                    When you arrive for your appointment you will be screened at
                    the entrance of the building and will be provided a mask
                    which is required while inside the building.<br />
                    <i
                      >*Exception to this rule are children under the age of
                      2yrs.</i
                    >
                  </li>
                  <li>
                    Unless you need help getting into the exam room, please do
                    not bring any additional family members or friends along to
                    your visit.
                  </li>`,
        financialScreening: `Bring all necessary documents to your appointment. We will
                      not be able to help determine what financial assistance
                      you qualify for if you do not bring the necessary
                      documents. If you cannot bring one or more of the
                      documents, please cancel your appointment and reschedule
                      once you have all the documentation.`,
        financialScreeningDisclaimer: `If you are requesting an appointment for Open Enrollment with Connect for Health Colorado, please call Clinica at <a href="tel:3036504460" >303.650.4460 </a> to schedule an appointment.`,
        financialScreeningDocuments: `<li>
                        Picture ID for all adult applicants.
                      </li>
                      <li>
                        Social Security numbers for all family members (if
                        applicable).
                      </li>
                      <li>
                        Legal Permanent Resident Card if resident of U.S., or
                        work permit (if applicable).
                      </li>
                      <li>
                        Proof of address under patient’s name such as public
                        service bills or other bills. Statement date should be
                        for previous or current month.
                      </li>
                      <li>
                        Insurance cards, for example: Medicaid, Medicare or
                        private health insurance, etc.
                      </li>
                      <li>
                        Proof of unearned income, for example: child support,
                        SSDI, SSI, or unemployment letter.
                      </li>
                      <li>
                        If self-employed, bring previous month business ledger.
                        The ledger needs to reflect total earning for the month
                        and total business expenses for the same month.
                      </li>
                      <li>
                        If pregnant, need to know expected delivery date. Bring
                        picture ID or birth Certificate and Social Security card
                        (if applicable).
                      </li>
                      <li>
                        Children under age 18: Passport, birth certificates,
                        Colorado ID or school ID (if applicable).
                      </li>
                      <li>
                        If paid with check stubs, all check stubs from previous
                        month. If you are paid with cash please provide a signed
                        and dated letter from your employer. Letter needs to
                        state the hours worked per week, pay per hour, pay
                        frequency and gross income from the last month. Make
                        sure your employer listed his/her phone number and
                        business address.
                      </li>
                      <li>
                        If shared residency: Bring a signed, dated letter from
                        the person you live with. The letter should include the
                        person’s name, address and, phone number. You will also
                        need to bring a bill dated the previous or current month
                        from the person writing the letter.
                      </li>`,
        schedulingFor: "Scheduling a new appointment for",
        gfeDisclaimer: `Under the law, healthcare providers need to give patients who don't have insurance or who are not using insurance an estimate of the bill for medical items and services. Your last 5 estimates can be viewed below.`,
        switchFamilyMember:
          "to schedule an appointment for someone other than ",
        switchFamilyMemberInstructions:
          "To schedule an appointment for a family member, please sign-in to the portal with their demographic information. You will need access to the phone number that we have on record for your family member in order to sign-in.",
        covidVaccineSchedule: "Your COVID vaccine will be scheduled at",
        covidVaccineScheduleReturn:
          "Pfizer booster shots can now be given at 5 months after your second dose. Moderna and J&J can be given at 6 months after your second dose. If a second dose is required, you must be available to receive your second dose on",
        limitedVaccineSpace:
          "Due to limited space, only the person being vaccinated and one parent/guardian for minors will be allowed into the clinic. If you are symptomatic at the time of your visit please reschedule. Anyone with fever or Covid19 symptoms will not be seen.",
        pcrCovidTest: `PCR`,
        rapidCovidTest: `rapid`,
        positiveCovidResult: `<b
              >Your COVID-19 (SARS-CoV-2) {testType} test returned positive. You have
              been diagnosed with a COVID-19 infection. You can limit the spread
              of COVID-19 by carefully following public health guidance:</b
            >
            <ul>
              <li>
                People with COVID-19 should isolate for 5 days and if they are asymptomatic or their symptoms are resolving (without fever for 24 hours), follow that by 5 days of wearing a mask when around others to minimize the risk of infecting people they encounter.
              </li>
              <li>
                If your condition worsens, call
                <a href="tel:3036504460">303-650-4460</a> to schedule a
                telehealth appointment or
                <a href="/en/scheduling"
                  >schedule a telehealth visit online.</a
                >
              </li>
              <li>
                If you have an in-person appointment scheduled during the time
                you’re self-isolating, please reschedule your visit or change it
                to a telehealth visit. You can also learn more about the
                difference between quarantining and isolating on the CDC
                website. Because positive PCR tests can linger for up to 90
                days, it is not recommended that you have repeat PCR testing to
                confirm that you are no longer contagious. If you meet the above
                criteria, you are safe to go back to your regular work and
                activity with usual precautions of masking and social
                distancing.
              </li>
            </ul>`,
        negativeCovidResult: ` <b
              >Your COVID-19 (SARS-CoV-2) {testType} test returned negative. Despite a
              negative COVID-19 test, you could still have a COVID-19 infection
              and be at risk for passing a COVID-19 infection due to a
              false-negative test. You can limit the spread of COVID-19 by
              carefully following public health guidance:</b
            >
            <ul>
              <li>
                If you have symptoms, you should remain in self-isolation and
                treat any symptoms at home until they start to improve and
                you're fever-free for 24 hours without use of fever reducing
                medication(s).
              </li>
              <li>
               If you were told to isolate due to possible COVID19 exposure and you are not fully vaccinated against COVID 19, you should stay home and limit interactions with others unless you need urgent care for at least 5 days after your last exposure and you should wear a well-fitted mask for at least 10 days after your last exposure.  However, even if you test negative after a COVID 19 exposure, remaining in quarantine for a full 10 days after your last exposure will maximally reduce your risk of passing an infection on to your close contacts.  If you are fully vaccinated against COVID19, you wear a well fitted mask and should monitor for symptoms for 10 days after your last exposure.  
              </li>
              <li>
                For further information on quarantine and isolation guidance from the CDC, <a href="https://www.cdc.gov/coronavirus/2019-ncov/your-health/quarantine-isolation.html">click here</a>
              </li>
              <li>
                If you have an in-person appointment scheduled during the time
                you’re self-isolating, please reschedule your visit or change it
                to a telehealth visit.
                <a href="/en/scheduling"
                  >Click here to schedule or cancel an appointment.</a
                >              
              </li>
            </ul>`,
        financialScreeningWalkIn: `{location} does not require financial screening appointments. To meet with a financial screener, please walk in between the following hours: <br />
            <b
              >Monday – Thursday<br />
              8am - 11am | 1pm - 4pm <br />
             <b> Wednesday - Thornton Only <br/>
             1pm - 7pm
             </b> 
              Friday<br />
              8am - 11am | 1:30pm - 3:30pm</b
            >
            <br />
            Please come prepared for your meeting with the required documents.
            <a
              href="https://www.clinica.org/patient-visitor-info-2/enroll/#enrollment-documents"
              target="_blank"
              >Click the link below for more information.</a
            >`,
        closeCareGap:
          "Please schedule the visit below to close a current care gap",
        goodFaithEstimate: `Under the law, healthcare providers need to give patients who don't have insurance or who are not using insurance an estimate of the bill for medical items and services. Your last 5 estimates can be viewed below.`,
        phoneVisit:
          "I specify I am in the state of COLORADO at the time of my Phone Visit.",
        virtualVisit:
          "I specify I am in the state of COLORADO at the time of my Virtual Visit.",
        preferredVisit:
          "Your PCP knows your story and can save you time. Always try to make appointments with your PCP.",
      },
      error: {
        newAppointmentsUnavailable:
          "We are currently unable to schedule new appointments online. Please call 303.650.4460 for a new appointment or try again later.",
        couldNotVerify: `Could not verify your identity, please try again.
        Call <a href="tel:3036504460" style="color:#FFFFFF">303.650.4460 </a>if you continue to experience issues. `,
        invalidCode: "Submitted code could not be verified, please try again.",
        notAvailable:
          "The previously selected time slot is no longer available. Please select a new time below.",
        authentication:
          "The scheduling platform is currently unavailable. Please try again later.",
        noPCP: `You are not assigned to a Primary Care Provider. Please contact us at <a href="tel:3036504460">303.650.4460 </a> for more information.`,
        reasonRequired: "Your appointment reason is required",
        answerRequired: "This question is required",
        tooManyAttempts: `Too many attempts. Please try again in 15 minutes. Call <a href="tel:3036504460" style="color:#FFFFFF">303.650.4460 </a> if you continue to experience issues.`,
        tryAgain:
          "There was an error creating your appointment. Please try again.",
        expiredLink:
          "The link you are using has expired or is invalid. Links expire 30 minutes after they are sent.",
        duplicateAppointment:
          "You already have an appointment scheduled for the selected date. Please select a different date or cancel your original appointment.",
        cookiesRequired:
          "Cookies are required for this site to function. Please enable first-party cookies in your web browser to continue. ",
        leaveAppointmentPage:
          "Are you sure you want to leave this page? All progress will be lost. ",
        initialPatientLoad: `There was an error loading your information. Please try again. If this issue continues, please call us at <a href="tel:3036504460" style="color:#FFFFFF">303.650.4460</a> to schedule or cancel an appointment.`,
      },
      button: {
        logOut: "Log Out",
        continue: "Continue",
        cancel: "Cancel Appointment",
        back: "Go Back",
        resendCode: "Resend Verification Code",
        resendVoice: "Send Code as Voice",
        verifyCode: "Verify Code",
        selectProvider: "Select Your Provider",
        selectDate: "Select Date and Time",
        confirmAppointment: "Review Appointment Details",
        scheduleAppointment: "Schedule A New Appointment",
        establishedPatient: "I am an established patient",
        newPatient: "I am a new patient",
        backHome: "Go back to home page",
        submitAnswers: "Submit Answers",
        reasonForVisit: "Reason for Visit",
        additionalInformation: "additional information",
        moreInformation: "more information",
        clickHereForInformation: "please click here for more information",
        select: "Select",
        close: "Close",
        completeForm: "Complete Form",
        submitted: "Submitted",
        loginAsFamilyMember: "Login as a Family Member",
        callback: `I have questions and would like a call back`,
        scheduleTelehealthVisit: `I have questions and would like to schedule a telehealth visit`,
        covidVaccineQualify: "I qualify Based on the conditions above",
        covidVaccineAttestation: `I confirm that I am a 50 years or older, a first responder or a healthcare worker. I have reviewed the requirements and I am eligible.`,
        getDirections: `Get directions`,
        searchAppointments: `Search {0} appointments`,
        availableAppointments: `View Appointments`,
        retry: "Retry",
        returnToVisitTypes: "Back to visit types",
        generatedOn: "Generated on",
      },
      label: {
        firstName: "First Name",
        lastName: "Last Name",
        phone: "Phone",
        virtual: "Virtual",
        time: "Time",
        dob: "Date of Birth",
        teamMember: "Team Member",
        date: "Date",
        location: "Location",
        code: "6 Digit Code",
        visitDetails: "",
        minutes: "Minutes",
        pcp: "Your PCP",
        careTeam: "Your Care Team",
        enrollmentSpecialist: "Enrollment Specialist",
        nextAvailable: "Available: ",
        noAppointments: "No appointments in the next 2 weeks",
        noAppointmentsPcp: "No appointments in the next 3 weeks",
        appointmentDetails: "Appointment Details",
        previsitForm: "Pre-Visit Form",
        reviewAndConfirm: "Review and Confirm",
      },
    },
    es: {
      heading: {
        appointment: "Citas",
        welcome: "Bienvenido!",
        verify: "Verifica Tu Numero de Telefono",
        enterCode: "Ingrese el código de 6 dígitos que enviamos a:",
        selectVisit: "Selecciona Tipo de Cita",
        visitDetails:
          "¿Cuál es la cosa más importante que usted le gustaría discutir durante esta visita?",
        selectProvider: "Selecciona un Proveedor",
        selectTime: "Fechas Disponibles son Seleccionables",
        confirmAppointment: "confirma cita",
        telehealthVisit: "¿Qué es una visita telefónica?",
        thankyouResponses: "Gracias Por Sus Respuestas",
        navigationHome:
          "Sus respuestas han sido enviadas. Ahora será llevado a la página de inicio.",
        inPersonVisits: "Visitas en persona se programarán en ",
        inPersonVisit: "Cita en Persona",
        telephoneVisit: "Cita Telefónica",
        virtualVisit: "Cita Virtual",
        availableForms: "Formas Disponibles",
        expiredLink: "Este Enlace Ya No Está Activo",
        goodMorning: "Buenos días",
        goodAfternoon: "Buenas tardes",
        goodEvening: "Buena noches",
        familyMemberInstructions: "Instrucciones",
        callbackRequestReceived: "Solicitud recibida",
        noAppointments:
          "Actualmente no hay citas disponibles en las próximas 2 semanas. Por favor, inténtelo de nuevo más tarde.",
        appointmentType: "¿Qué te gustaría programar?",
        schedulingYourVisit: "Programa su {0}",
        howMayWeHelp: "¿Cómo podemos ayudarte hoy?",
        upcomingAppointments: "Sus citas",
        recommendedCare: "Atención Recomendada",
        goodFaithEstimate: "Estimación De Buena Fe",
      },
      common: {
        with: "con",
        at: "a las",
        telehealth: "Telefono",
        yes: "si",
        no: "no",
        cancel: "¿Cancelar Cita?",
        where: "en",
        clickHere: "Haga clic",
        notDetected: "no detectado",
        detected: "detectado",
        positive: "positivo",
        negative: "negativo",
        ordered: "ordenado",
        before: "antes de",
      },
      information: {
        loggedOut: "Por motivos de seguridad, has sido desconectado.",
        inactive:
          "Debido a la inactividad, por favor llame al Centro de Comunicación para programar su próxima cita al (303) 650-4460.",
        lafayetteDoubleBook:
          "Este servicio no está disponible temporalmente. Estamos trabajando para restablecerlo lo antes posible. Por favor, llame al Centro de Comunicaciones para programar su próxima cita al (303) 650-4460. ¡Gracias por su paciencia!",
        dentalEvent:
          "Ud. ha seleccionado agendar una cita para su examen dental. Por favor tenga en cuenta que opciones para hacer cita solo aparecerán si ya le toca su examen dental. Para agendar cualquier otro tipo de cita dental, por favor háblenos al 303-650-4460.",
        inactiveTooLong:
          "Nuestros registros indican que han pasado más de 3 años desde la última vez que vio a un proveedor médico en Clinica Family Health & Wellness. Por favor, llame a nuestro Centro de Comunicación al 303.650.4460 para verificar si es elegible para restablecer su atención en Clinica. Gracias.",
        noShow:
          "Debido a una cita perdida previamente, su atención ha sido terminada. Por favor, llame al Centro de Comunicación para más asistencia al (303) 650-4460.",
        fullPayOneTime:
          "No puede programar una cita hasta que se reúna con un Especialista en Inscripción. Por favor, llame a nuestro Centro de Comunicación al 303.650.4460 para programar una cita con el equipo de Inscripción o para obtener más información sobre los horarios de atención sin cita previa del departamento de Inscripción. Gracias.",
        fullPayDeclined:
          "Nuestros registros indican que no tiene cobertura de seguro activa o un descuento de Clinica.",
        fullPayDeclinedReminder:
          "RECORDATORIO: Se le requiere pagar el cargo de visita de $150 por adelantado durante el registro para esta cita o la cita será cancelada.",
        fullPayDeclinedEnd:
          "Si tiene actualizaciones sobre su estado de seguro, por favor llámenos al 303.650.4460 antes de su cita o traiga su nueva tarjeta de seguro a su visita. Gracias.",
        fullPayDeclinedWest:
          "El acceso a exámenes de bienestar para adultos está limitado en Westminster. Si tiene una necesidad médica fuera de un examen físico o de bienestar, por favor llame al Centro de Comunicación al 303.650.4460 para discutir opciones de programación. Gracias.",
        outOfServiceArea:
          "Nuestros registros indican que usted se encuentra fuera del área de servicio de Clinica. Por favor, verifique si es elegible para restablecer su atención con Clinica. Para obtener más ayuda, llame a nuestro Centro de Comunicación al (303) 650-4460. Gracias.",
        lafayetteParking:
          "Parte de nuestro estacionamiento de Lafayette se está utilizando para apoyar a nuestra comunidad afectada por el incendio de Marshall. Se ha conservado el estacionamiento para pacientes más cercano al edificio. Por favor, busque aquí el estacionamiento.",
        covidVaccineLocations: `Seleccione su ubicación preferida a continuación.`,
        covidVaccineDisclaimer:
          "Las vacunas de COVID no se pueden programar usando las siguientes opciones. Si es elegible para una vacuna basada en las pautas estatales actuales",
        covidVaccineOffered:
          "Ahora estamos ofreciendo la vacuna COVID-19 de Pfizer a pacientes elegibles. ¡Haga clic para revisar la elegibilidad y programar su vacuna ahora!",
        callbackRequestReceived: `Nuestro personal le devolverá la llamada para tratar sus preguntas sobre la vacuna COVID.
       Tenga en cuenta que actualmente estamos experimentando un alto volumen de llamadas y un
       la llamada de regreso puede tardar más de 24 horas. No envíe varios
       solicitudes de llamada. Gracias por su paciencia.`,
        covidPhase1: `<b
        >Clinica Family Health & Wellness ofrece ahora las vacuna de Pfizer COVID-19 a nuestros pacientes que son mayores de 12 años.</b
      >
     `,
        covidPhase1Requirements: `<b
        >IMPORTANTE: Si usted es un primero en responder o un trabajador de salud, debe traer a su cita la comprobación del empleo. Las formas aceptables de verificación incluyen: </b
      >Acceptable forms of verification include:
      <ul class="pb-2">
        <li>
         Gafete con foto del empleado
        </li>
        <li>Talón de pago e identificación</li>
        <li>Carta del empleador e identificación</li>
      </ul>
      <b class="error--text"
        >De acuerdo con las órdenes del estado, no podemos vacunar a los individuos que no están en esta fase del plan de vacunación. </b
      >Por favor, consulte el
      <a href="https://www.clinica.org" target="_blank">sitio web de Clinica</a> 
      para obtener más información sobre cuándo puede recibir la vacuna.`,
        established:
          "Puede programar en línea la mayoría de las citas no urgentes con su equipo medico. Programe su cita a continuación.",
        //"Programe su propia <b class = 'primary-- text'> visita telefónica o en persona </b> y complete los cuestionarios previos a la visita.",
        virtualVisits: `¡A partir de mayo de 2021, Clínica ofrecerá visitas virtuales por video! Su equipo de atención espera verlo para asegurarse de que se satisfagan sus necesidades de atención médica. Para obtener más información sobre qué esperar, visite: <a target='_blank' href='https://www.lumahealth.io/telehealth-guides/telehealth-patient/'>Guía del usuario</a>`,
        emergency:
          "Si cree que tiene una emergencia médica o de salud mental, llame al 9-1-1 o vaya a la sala de urgencias más cercano.",
        enter: "Ingrese su informacion",
        bhEmergency: `Si cree que tiene una emergencia médica o de salud mental, llame al 9-1-1 o al Línea de Crisis Colorado <a href="tel:18444938255">1-844-493-8255</a>`,
        prapareInfo: `Por favor, complete esta encuesta; nos ayuda a comprender sus necesidades y brindarle una mejor atención`,
        noUpcomingAppointments:
          "No tienes citas próximas.<br/> Programe uno usando el ícono + arriba.",
        checkIn:
          "Su hora de llegada es a las {time}. Por favor traiga su tarjeta de seguro a su cita.",
        noUpcomingAppointmentsBelow:
          "No tienes citas próximas. Programe una nueva cita a continuación.",
        upcomingAppointment: "Tienes una cita próxima",
        upcomingAppointments: "Tienes {number} citas próximas",
        telehealthCheckin:
          "Nos pondremos en contacto con usted por teléfono dentro de {time} minutos de su hora de la cita. Recomendamos atender su llamada desde un espacio tranquilo si es posible",
        telehealthVisit:
          "Una visita regular entre usted y su proveedor, pero en lugar de reunirse en persona, su visita se realiza por teléfono usando solo audio.",
        virtualVisit:
          "Una visita regular entre usted y su proveedor, pero en lugar de reunirse en persona, su visita se realiza por teléfono o computadora usando video y audio",
        preferredVisit:
          "Su Provedor conoce su historia y puede ahorrarle tiempo. Intente siempre programar citas con su provedor.",

        enteredInformation:
          "Esta información debe coincidir con su registro de salud. Necesitará acceso al número de teléfono ingresado a continuación para recibir su código de verificación.",
        quickLoginInformation:
          "Esta información debe coincidir con su registro de salud.",
        expiredQuickLink: `El enlace que ha utilizado está caducado o no es válido. Por favor llámenos al <a href="tel:3036504460"> 303-650-4460 </a> si tiene alguna pregunta sobre su prueba COVID más reciente.`,
        expiredQuickLinkVaccine: `El enlace que ha utilizado está caducado o no es válido. Por favor, haga clic abajo para programar su vacuna covid.`,
        obDisclaimer: `Si esta es su primera cita con Clinica para <u>este embarazo</u>, llame al <a href="tel:3036504460">303.650.4460</a> para programar una visita.`,
        procedureDisclaimer: `No programe un procedimiento (inserciones / extracciones de DIU, vasectomías, inyecciones en las articulaciones, extracción de verrugas, extracción de yesos, etc.) utilizando este sistema. Para brindar una gran experiencia, llame al <a href="tel:3036504460">303.650.4460</a> para que podamos asegurarnos de que se le programe con un proveedor que pueda realizar su procedimiento.`,
        wellnessDisclaimer: `Si tiene más de 65 años, tenga en cuenta que su cita se asignará un intervalo de tiempo de 40 minutos para asegurar una consulta completa y atenta.`,
        insurance: "Por favor traiga su tarjeta de seguro a su cita.",
        invalidStatus: `No podemos procesar su solicitud para programación de cita en este momento; llame a la clinica al <a href="tel:3036504460">303.650.4460</a> para programar una cita.`,
        zpayStatus: `Si usted no tiene cobertura médica en el momento de su cita, se pondrá en un contrato de 30 días al registrarse el dia de la cita. Para preguntas sobre el contrato de 30 días por favor llame a la clinica al <a href="tel:3036504460">303.650.4460</a>.`,
        inPersonVisit: `<h4>Por favor limite cualquier acompañante a su cita:</h4>
                  <li>El acceso al edificio ahora está restringido. Solo la persona con la cita, 1 padre o guardián acompañando a un menor o un paciente que ocupe la ayuda de 1 cuidador podrán entrar al edificio.
                  </li>
                  <li>
                    Cuando llegue a su cita, se le examinará en la entrada del edificio y se le proporcionará una máscara que se requiere mientras esté dentro del edificio. <br />
                    <i
                      >*La excepción a esta regla son niños menores de 2 años</i
                    >
                  </li>
                  <li>
                   A menos que necesite ayuda para entrar al cuarto de examinación por favor no traiga a ningún miembro adicional de su familia o amigos a su visita.
                  </li>`,
        financialScreening: `Lleve todos los documentos necesarios a su cita. No podremos ayudar a determinar para qué asistencia financiera califica si no trae los documentos necesarios. Si no puede traer uno o más de los documentos, cancele su cita y reprograme una vez que tenga toda la documentación.`,
        financialScreeningDisclaimer: `Si solicita una cita para la inscripción abierta con El Mercado oficial de seguros de salud de Colorado, llame a Clínica <a href="tel:3036504460">303.650.4460 </a> para programar una cita.`,
        financialScreeningWalkIn: `{location} no requiere citas para la financiera. Para
            reunirse con una de nuestras Financieras, favor de venir en las
            siguientes horas: <br />
            <b
              >Lunes – Jueves <br />
              8am - 11am | 1pm - 4pm <br />
            Miercoles - Sólo Thornton <br />
             1pm - 7pm <br />
              Viernes<br />
              8am - 11am | 1:30pm - 3:30pm</b
            >
            <br />
            Para facilitar su cita favor de venir preparado para su reunión con
            los documentos requeridos.
            <a
              href="https://www.clinica.org/patient-visitor-info-2/enroll/#enrollment-documents"
              target="_blank"
              >Haga clic para obtener más información.</a
            >`,
        financialScreeningDocuments: `<li>
                        Identificación con fotografía para todos los solicitantes adultos.
                      </li>
                      <li>
                       Números de seguro social de todos los miembros de la familia (si corresponde).
                      </li>
                      <li>
                       Tarjeta de residente permanente legal si es residente de EE. UU. O permiso de trabajo (si corresponde).
                      </li>
                      <li>
                       Comprobante de domicilio a nombre del paciente, como facturas de servicio público u otras facturas. La fecha del estado de cuenta debe ser para el mes anterior o el actual.
                      </li>
                      <li>
                       Tarjetas de seguro, por ejemplo: Medicaid, Medicare o seguro médico privado, etc.
                      </li>
                      <li>
                        Comprobante de ingresos no derivados del trabajo, por ejemplo: manutención infantil, SSDI, SSI o carta de desempleo.
                      </li>
                      <li>
                        Si trabaja por cuenta propia, lleve el libro de contabilidad del mes anterior. El libro mayor debe reflejar las ganancias totales del mes y los gastos comerciales totales del mismo mes.
                      </li>
                      <li>
                       Si está embarazada, debe saber la fecha de parto prevista. Traiga una identificación con foto o certificado de nacimiento y tarjeta de Seguro Social (si corresponde).
                      </li>
                      <li>
                        Niños menores de 18 años: pasaporte, certificados de nacimiento, identificación de Colorado o identificación escolar (si corresponde).
                      </li>
                      <li>
                       Si se paga con talones de cheques, todos los talones de cheques del mes anterior. Si le pagan en efectivo, proporcione una carta firmada y fechada de su empleador. La carta debe indicar las horas trabajadas por semana, el pago por hora, la frecuencia de pago y los ingresos brutos del último mes. Asegúrese de que su empleador indique su número de teléfono y dirección comercial.
                      </li>
                      <li>
                        Si es residencia compartida: Traiga una carta firmada y fechada de la persona con la que vive. La carta debe incluir el nombre, la dirección y el número de teléfono de la persona. También deberá traer una factura con fecha del mes anterior o actual de la persona que escribe la carta.
                      </li>`,
        schedulingFor: "Programar una nueva cita para",
        gfeDisclaimer: `Según la ley, los proveedores de atención médica deben proporcionar a los pacientes que no tienen seguro o que no usan seguro una estimación de la factura de los artículos y servicios médicos. Sus 5 estimaciones más recientes se pueden ver a continuación.`,
        switchFamilyMember:
          "aquí para programar una cita para alguien que no sea ",
        switchFamilyMemberInstructions:
          "Para programar una cita para un miembro de la familia, inicie sesión en el portal con su información demográfica. Necesitará acceso al número de teléfono que tenemos registrado para el miembro de su familia para poder iniciar sesión.",
        covidVaccineSchedule: "Su vacuna para el COVID-19 se programará en",
        covidVaccineScheduleReturn:
          "Las inyecciones de refuerzo de Pfizer ahora se pueden administrar 5 meses después de su segunda dosis. Moderna y J&J se pueden administrar 6 meses después de su segunda dosis. Si se requiere una segunda dosis, debe estar disponible para recibir su segunda dosis el",
        limitedVaccineSpace:
          "Debido al espacio limitado, solamente el paciente siendo vacunado y un padre o tutor de menores se le permitirá entrar a la clínica.",
        pcrCovidTest: `de reacción en cadena de la polimerasa (Polymerase Chain Reaction, PCR)`,
        rapidCovidTest: `rapida`,
        positiveCovidResult: `<b
              >La prueba {testType} del COVID-19 (SARS-CoV-2) que realizó en Clinica Family Health & Wellness es POSITIVA, lo que significa que tiene una infección por coronavirus. Puede limitar la propagación del COVID-19 siguiendo cuidadosamente estas pautas: </b
            >
            <ul>
              <li>
               Las personas con COVID-19 deben aislarse por 5 días y, si están asintomáticas o sus síntomas están desapareciendo (sin tener fiebre por 24 horas), continuar después usando mascarilla por 5 días cuando estén cerca de otras personas para minimizar el riesgo de infectarlas.
              </li>
              <li>
              Si su condición empeora, llame a Clinica al <a href="tel:3036504460">303-650-4460</a> para una cita. También puede  programar su propia consulta de telesalud <a href="/es/scheduling">en línea</a
                >.
              </li>
                    <li>
            	Si tiene programada una cita presencial mientras está aislado, reprográmela o cámbiela a una consulta de telesalud. Puede hacerlo llamándonos al <a href="tel:3036504460">303-650-4460</a> o <a href="/es/scheduling"> en línea</a
                >.
              </li>
              <li>
                Para obtener más información sobre la diferencia entre cuarentena y aislamiento, visite el sitio web de los <a href="www.cdc.gov/coronavirus" target="_blank>Centros para el Control y la Prevención de Enfermedades (Centers for Disease Control and Prevention, CDC)</a>. 
Debido a que las pruebas de PCR positivas pueden durar hasta 90 días, no recomendamos que se haga otra prueba para confirmar que ya no es contagioso. Si cumple con las pautas anteriores, puede volver de manera segura a su trabajo y actividades regulares, pero asegúrese de usar una mascarilla y mantenerse al menos a 6 pies de distancia de los demás.
          </i18n>
              </li>
            </ul>`,
        negativeCovidResult: ` <b
              >La prueba {testType} del COVID-19 (SARS-CoV-2) que realizó en Clinica Family Health & Wellness es negativa.  A pesar de una prueba de la COVID-19 NEGATIVA, podría tener incluso una infección por coronavirus y correr el riesgo de transmitirlo a otras personas. Puede limitar la propagación de la COVID-19 siguiendo cuidadosamente estas pautas:</b
            >
            <ul>
              <li>
               Si tiene síntomas, debe aislarse y tratarlos en casa hasta que empiecen a mejorar y no tenga fiebre durante 24 horas sin usar medicamento(s) para reducirla.
              </li>
              <li>
               Si le dijeron que se aislara debido a una posible exposición al COVID19 y no está completamente vacunado contra el COVID 19, debe quedarse en casa y limitar las interacciones con los demás a menos que necesite atención de urgencia durante al menos 5 días después de su última exposición y debe usar una buena -máscara ajustada durante al menos 10 días después de su última exposición. Sin embargo, incluso si obtiene un resultado negativo después de una exposición al COVID 19, permanecer en cuarentena durante 10 días completos después de su última exposición reducirá al máximo el riesgo de transmitir una infección a sus contactos cercanos. Si está completamente vacunado contra COVID19, usa una máscara bien ajustada y debe monitorear los síntomas durante 10 días después de su última exposición.
              </li>
              <li>
                Para obtener más información sobre la guía de cuarentena y aislamiento de los CDC, <a href="https://espanol.cdc.gov/coronavirus/2019-ncov/your-health/quarantine-isolation.html">haga clic aquí</a>
              </li>
              <li>
                Si tiene programada una cita médica en persona mientras esté aislado, reprograme o cambie la cita a una consulta de telesalud. Puede llamarnos al <a href="tel:3036504460">303-650-4460</a> o <a href="/es/scheduling">en línea</a
                >.
              </li>
            </ul>`,
        closeCareGap:
          "Programe la visita a continuación para completar una necesidad médica",
        goodFaithEstimate: `Según la ley, los proveedores de atención médica deben brindarles a los pacientes que no tienen seguro o que no utilizan un seguro una estimación de la factura por artículos y servicios médicos. Sus últimas 5 estimaciones se pueden ver a continuación.`,
      },

      error: {
        newAppointmentsUnavailable: `Actualmente no podemos programar nuevas citas en línea. Llame al 303.650.4460 para programar una nueva cita o vuelva a intentarlo más tarde.`,
        couldNotVerify:
          "No se pudo verificar su identidad, por favor trate de nuevo. Llame al 303.650.4460 si continúa teniendo problemas.",
        invalidCode:
          "El código enviado no pudo ser verificado, por favor intente nuevamente.",
        notAvailable:
          "El intervalo de tiempo previamente seleccionado ya no está disponible. Por favor seleccione una nueva hora a continuación.",
        authentication:
          "La aplicación de programación no está disponible actualmente. Por favor intente nuevamente más tarde.",
        noPCP: `No está asignado a un proveedor de atención primaria. Por favor contáctenos al <a href="tel:3036504460">303.650.4460 </a> para más información.`,
        reasonRequired: "Se requiere su razón de cita",
        answerRequired: "Se requiere su respuesta",
        tooManyAttempts:
          "Demasiados intentos. Por favor intente nuevamente en 15 minutos. Llame al 303.650.4460 si continúa teniendo problemas.",
        tryAgain: "Hubo un error al crear la cita. Por favor intente de nuevo.",
        expiredLink:
          "El enlace que está utilizando ha caducado o no es válido. Los enlaces caducan 30 minutos después de su envío.",
        duplicateAppointment:
          "Ya tienes una cita programada para la fecha seleccionada. Seleccione una fecha diferente o cancele su cita original.",
        cookiesRequired:
          "Las cookies son necesarias para que este sitio funcione. Por favor, activa las cookies de origen en su navegador web para continuar.",
        leaveAppointmentPage:
          "¿Estás seguro de que quieres salir de esta página? Se perderá todo el progreso.",
        initialPatientLoad: `Hubo un error al cargar su información. Por favor intente de nuevo. Si este problema continúa, llámenos al <a href="tel:3036504460" style="color:#FFFFFF">303.650.4460</a> para programar o cancelar una cita.`,
      },
      button: {
        logOut: "Cerrar Sesión",
        continue: "Continuar",
        cancel: "Cancelar Cita",
        back: "Regresa",
        resendCode: "Reenviar Código de Verificación",
        resendVoice: "Enviar código como voz",
        verifyCode: "Verificar código",
        selectProvider: "Selecciona un Proveedor",
        selectDate: "Seleccione Fecha y Hora",
        confirmAppointment: "Confirmar detalles de la cita",
        scheduleAppointment: "Programar una nueva cita",
        establishedPatient: "Soy un paciente establecido",
        newPatient: "Soy un nuevo paciente",
        submitAnswers: "Enviar respuestas",
        backHome: "Volver a la página principal",
        reasonForVisit: "Detalles de la Visita",
        select: "Seleccione",
        additionalInformation: "Información Adicional",
        moreInformation: "más información",
        clickHereForInformation: "haga clic aquí para obtener más información",
        close: "Cerrar",
        completeForm: "Completa Forma",
        submitted: "Presentada",
        loginAsFamilyMember: "Inicie sesión como familia",
        callback: `Tengo preguntas y me gustaría que me llamen`,
        scheduleTelehealthVisit: `Tengo preguntas y me gustaría programar una visita telefónica.`,
        covidVaccineQualify: "Califico en base a las condiciones anteriores",
        covidVaccineAttestation: `Confirmo que soy una persona de 50 años o más, un primer nivel de respuesta o un trabajador de la salud. He revisado los requisitos y soy elegible.`,
        getDirections: `Obtener direcciones`,
        searchAppointments: `Buscar citas en {0}`,
        availableAppointments: `Ver citas`,
        retry: "reintentar",
        returnToVisitTypes: "volver a tipos de visita",
        generatedOn: "Generado en",
      },
      label: {
        firstName: "Primer Nombre",
        lastName: "Apellido",
        phone: "Teléfono",
        virtual: "Virtual",
        dob: "Fecha de Nacimiento",
        date: "Fecha",
        time: "Hora",
        teamMember: "Miembro del Equipo",
        location: "Sitio",
        code: "Código de 6 dígitos",
        visitDetails: "Detalles Adicionales de la Cita",
        minutes: "Minutos",
        pcp: "Su PCP",
        careTeam: "Su Equipo Médico",
        enrollmentSpecialist: "Especialista de Inscripción",
        reviewAndConfirm: "Revisar y Confirmar",
        nextAvailable: "Próxima Cita Disponible: ",
        noAppointments: "No hay citas en las próximas 2 semanas",
        noAppointmentsPcp: "No hay citas en las próximas 3 semanas",
        appointmentDetails: "Detalles de la cita",
        previsitForm: "Formulario de Pre-Visita",
      },
    },
  },
});
